import { render, staticRenderFns } from "./select-inbox.vue?vue&type=template&id=1de0aace&scoped=true&"
import script from "./select-inbox.vue?vue&type=script&lang=js&"
export * from "./select-inbox.vue?vue&type=script&lang=js&"
import style0 from "./select-inbox.vue?vue&type=style&index=0&id=1de0aace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de0aace",
  null
  
)

export default component.exports